<template>
  <div>
    <div class="col-xs-12">
      <p>{{ trans('subscription.exams.explanation_subscribable', { capacity: capacity }) }}</p>
    </div>

    <br style="clear:both">

    <div class="subscribable-details">
      <form class="form-horizontal row">
        <div
          class="col-xs-12 form-group"
          style="margin-bottom: 20px;"
        >
          <label
            class="control-label col-sm-3"
            :for="'select_startdate_' + subscribable.id"
          >
            {{ trans('subscription.startdate_short') }}</label>
          <div
            class="col-sm-9 col-md-9"
            style="z-index: 0;"
          >
            <div class="col-xs-6 no-padding-side">
              <query-date-picker
                :id="'select_startdate_' + subscribable.id"
                v-model="startdate"
                :value="startdate"
                :class="[{ 'error':error('startdate') }]"
                @input="selectValue({ attribute: 'startdate', value: startdate })"
              />
            </div>
            <div class="col-xs-6 no-padding-side">
              <input
                v-model="sub_start_time"
                name="sub_start_time"
                type="text"
                :class="[{ 'form-control':true,'error':error('sub_start_time') }]"
                :placeholder="trans('core.time_format_seconds')"
                @input="selectValue({ attribute: 'sub_start_time', value: sub_start_time })"
              >
            </div>
            <p
              v-if="error('startdate') || error('sub_start_time') "
              class="help-block validation-text"
            >
              {{ error('startdate') }} {{ error('sub_start_time') }}
            </p>
          </div>
        </div>
        <div
          class="col-xs-12 form-group"
          style="margin-bottom: 20px;"
        >
          <label
            class="control-label col-sm-3"
            :for="'select_deadline' + subscribable.id"
          >{{ trans('subscription.deadline_short') }}</label>

          <div
            class="col-sm-9 col-md-9"
            style="z-index: 0;"
          >
            <div class="col-xs-6 no-padding-side">
              <query-date-picker
                v-model="deadline"
                :for="'select_deadline' + subscribable.id"
                :value="deadline"
                :class="[{ 'error':error('deadline') }]"
                @input="selectValue({ attribute: 'deadline', value: deadline })"
              />
            </div>
            <div class="col-xs-6 no-padding-side">
              <input
                v-model="sub_deadline_time"
                name="sub_deadline_time"
                class="form-control"
                type="text"
                :placeholder="trans('core.time_format_seconds')"
                :class="[{ 'form-control':true,'error':error('sub_deadline_time') }]"
                @input="selectValue({ attribute: 'sub_deadline_time', value: sub_deadline_time })"
              >
            </div>
            <p
              v-if="error('deadline') || error('sub_deadline_time')"
              class="help-block validation-text"
            >
              {{ error('deadline') }} {{ error('sub_deadline_time') }}
            </p>
          </div>
        </div>

        <div class="col-xs-12 form-group">
          <label
            for="select_groups"
            class="control-label col-sm-3"
          >{{ trans_choice('core.groups',2) }}</label>
          <div
            class="col-sm-9"
            style="z-index: 0;"
          >
            <query-magic-suggest
              id="select_groups"
              v-model="subscribable_groups"
              style="z-index: 250"
              suggest_type="group"
              :value="subscribable_groups"
              :exclude="subscribable_groups != null && subscribable_groups !== [] ? { 'group_id': subscribable_groups } : {}"
              :include="{ year:[years] }"
              :placeholder="trans('core.type_or_click') + '...'"
              :class="[{ 'error':error('subscribable_groups') }]"
              @input="selectValue({ attribute: 'subscribable_groups', value: subscribable_groups })"
            />
            <p
              v-if="error('subscribable_groups')"
              class="help-block validation-text"
            >
              {{ error('subscribable_groups') }}
            </p>
          </div>
        </div>

        <div class="col-xs-12 form-group">
          <h4
            style="padding-left: 15px; cursor:pointer"
            @click="showOptions = !showOptions"
          >
            <span
              id="advanced_settings_chevron"
              :class="{ 'fa fa-caret-down': showOptions, 'fa fa-caret-right': !showOptions }"
            />
            {{ trans('subscription.advanced_settings') }}
          </h4>
        </div>

        <div
          v-if="showOptions"
          id="advanced_settings"
        >
          <!-- description -->
          <div class="col-xs-12 form-group">
            <label
              class="control-label col-sm-3"
              for="description"
            >{{ trans('core.description') }}</label>
            <div
              class="col-sm-9"
              style="z-index: 0;"
            >
              <textarea
                id="description"
                v-model="description"
                class="form-control"
                rows="2"
                :placeholder="trans('core.description') + '...'"
                :class="[{ 'error':error('description') }]"
                @input="selectValue({ attribute: 'description', value: description })"
              />
              <p
                v-if="error('description')"
                class="help-block validation-text"
              >
                {{ error('description') }}
              </p>
            </div>
          </div>

          <!-- unsubscription deadline -->
          <div
            class="col-xs-12 form-group"
            style="margin-bottom: 20px;"
          >
            <label
              class="control-label col-sm-3"
              :for="'with_unsubscription' + subscribable.id"
            >{{ trans('subscription.with_unsubscription') }}</label>

            <div
              class="col-sm-9"
              style="z-index: 0; width: 50px;"
            >
              <input
                :id="'with_unsubscription' + subscribable.id"
                v-model="with_unsubscription"
                name="with_unsubscription"
                class="form-control"
                type="checkbox"
                style="height: 15px;"
                :class="[{ 'form-control':true,'error':error('with_unsubscription') }]"
                @change="selectValue({ attribute: 'with_unsubscription', value: with_unsubscription })"
              >
            </div>
          </div>

          <div
            v-if="with_unsubscription"
            class="col-xs-12 form-group"
            style="margin-bottom: 20px;"
          >
            <label
              class="control-label col-sm-3"
              :for="'select_unsubscription_deadline' + subscribable.id"
            >{{ trans('subscription.unsubscription_deadline_short') }}</label>

            <div
              class="col-sm-9 col-md-9"
              style="z-index: 0;"
            >
              <div class="col-xs-6 no-padding-side">
                <query-date-picker
                  :id="'select_unsubscription_deadline' + subscribable.id"
                  v-model="unsubscription_deadline"
                  :value="unsubscription_deadline"
                  :class="[{ 'error':error('unsubscription_deadline') }]"
                  @input="selectValue({ attribute: 'unsubscription_deadline', value: unsubscription_deadline })"
                />
              </div>
              <div class="col-xs-6 no-padding-side">
                <input
                  v-model="sub_unsubscription_deadline_time"
                  name="sub_unsubscription_deadline_time"
                  class="form-control"
                  type="text"
                  :placeholder="trans('core.time_format_seconds')"
                  :class="[{ 'form-control':true,'error':error('sub_unsubscription_deadline_time') }]"
                  @input="selectValue({ attribute: 'sub_unsubscription_deadline_time', value: sub_unsubscription_deadline_time })"
                >
              </div>
              <p
                v-if="error('unsubscription_deadline') || error('sub_unsubscription_deadline_time')"
                class="help-block validation-text"
              >
                {{ error('unsubscription_deadline') }} {{
                  error('sub_unsubscription_deadline_time') }}
              </p>
            </div>
          </div>

          <!-- minimum subscriptions -->
          <div class="col-xs-12 form-group">
            <label
              class="control-label col-sm-3"
              for="with_minimum_subscriptions"
            >{{ trans('subscription.with_minimum_subscriptions') }}</label>
            <div
              class="col-sm-9"
              style="z-index: 0;  width: 50px"
            >
              <input
                id="with_minimum_subscriptions"
                v-model="with_minimum_subscriptions"
                type="checkbox"
                class="form-control"
                style="height: 15px;"
                value="1"
                @input="selectValue({ attribute: 'with_minimum_subscriptions', value: !with_minimum_subscriptions })"
              >
              <p
                v-if="error('with_minimum_subscriptions')"
                class="help-block validation-text"
              >
                {{ error('with_minimum_subscriptions') }}
              </p>
            </div>
          </div>

          <div
            v-if="with_minimum_subscriptions == 1"
            class="col-xs-12 form-group"
          >
            <label
              class="control-label col-sm-3"
              for="minimum_subscriptions"
            >{{ trans('core.minimum_subscriptions') }}</label>
            <div
              class="col-sm-9"
              style="z-index: 0"
            >
              <input
                id="minimum_subscriptions"
                v-model="minimum_subscriptions"
                class="form-control"
                type="number"
                min="0"
                :placeholder="trans('core.minimum_subscriptions')"
                :class="[{ 'error':error('minimum_subscriptions') }]"
                @input="selectValue({ attribute: 'minimum_subscriptions', value: minimum_subscriptions })"
              >
              <p
                v-if="error('minimum_subscriptions')"
                class="help-block validation-text"
              >
                {{ error('minimum_subscriptions') }}
              </p>
            </div>
          </div>

          <!-- Group subscriptions -->
          <div
            v-if="can_subscribe_group_members"
            class="col-xs-12 form-group"
          >
            <label
              class="control-label col-sm-3"
              for="student_can_subscribe_group_members"
            >{{ trans('subscription.student_can_subscribe_group_members_short') }}</label>
            <div
              class="col-sm-9"
              style="z-index: 0;  width: 50px"
            >
              <input
                id="student_can_subscribe_group_members"
                v-model="student_can_subscribe_group_members"
                type="checkbox"
                class="form-control"
                style="height: 15px;"
                value="1"
                @input="selectValue({ attribute: 'student_can_subscribe_group_members', value: !student_can_subscribe_group_members })"
              >
              <p
                v-if="error('student_can_subscribe_group_members')"
                class="help-block validation-text"
              >
                {{ error('student_can_subscribe_group_members') }}
              </p>
            </div>
          </div>

          <!-- questions (only non-open question types for now) -->
          <div class="col-xs-12 form-group">
            <p style="padding-left: 15px">
              {{ trans('subscription.question_explanation') }}
            </p>
            <label
              class="control-label col-sm-3"
              for="questions"
            >{{ trans('subscription.questions') }}</label>
            <div
              class="col-sm-9"
              style="z-index: 0;"
            >
              <query-magic-suggest
                id="questions"
                v-model="questions"
                style="z-index: 250"
                suggest_type="question-template"
                :value="questions"
                :include="{ category: 'subscribable' }"
                :exclude="questions != null && questions !== [] ? { 'id': questions, 'type': 'open' } : { 'type': 'open' }"
                :placeholder="trans('core.type_or_click') + ' ...'"
                :class="[{ 'error':error('questions') }]"
                @input="selectValue({ attribute: 'questions', value: questions })"
              />
              <p
                v-if="error('question')"
                class="help-block validation-text"
              >
                {{ error('question') }}
              </p>
            </div>
          </div>

          <!-- Subscribable queue -->
          <div class="col-xs-12 form-group">
            <label
              class="control-label col-sm-3"
              for="with_queue"
            >{{ trans('subscription.with_queue') }}</label>
            <div
              class="col-sm-9"
              style="z-index: 0;  width: 50px"
            >
              <input
                id="with_queue"
                v-model="with_queue"
                type="checkbox"
                class="form-control"
                style="height: 15px;"
                value="1"
                @input="selectValue({ attribute: 'with_queue', value: !with_queue })"
              >
              <p
                v-if="error('with_queue')"
                class="help-block validation-text"
              >
                {{ error('with_queue') }}
              </p>
            </div>
          </div>
        </div>
      </form>
    </div>

    <p><strong>{{ trans('core.remark') }}</strong> {{ trans('subscription.warning_message_will_be_sent') }}</p>
  </div>
</template>

<script>
import QueryMagicSuggest from '../QueryMagicSuggest'
import QueryDatePicker from '../QueryDatePicker.vue'

export default {

  name: 'Subscribable',
  components: { QueryMagicSuggest, QueryDatePicker },

  props: {
    errors: {
      default: null,
    },
    start_time: {
      default: null,
    },
    deadline_time: {
      default: null,
    },
    can_subscribe_group_members: {
      required: false,
      default: 0,
      type: Number,
    },
  },

  data () {
    return {
      subscribable_groups: null,
      startdate: null,
      sub_start_time: null,
      deadline: null,
      sub_deadline_time: null,
      unsubscription_deadline: null,
      sub_unsubscription_deadline_time: null,
      with_unsubscription: false,
      with_minimum_subscriptions: false,
      with_queue: false,
      minimum_subscriptions: null,
      description: null,
      showErrors: null,
      questions: null,
      questions_order: null,
      showOptions: false,
      student_can_subscribe_group_members: false,
    }
  },

  computed: {
    subscribable () {
      return this.$store.state.exams.subscribable
    },

    capacity () {
      let capacity = 0
      Object.values(this.exams).forEach(exam => {
        capacity = capacity + exam.attributes.classroom_capacity
      })

      return capacity
    },
    exams () {
      return this.$store.state.exams.exams
    },
    years () {
      if (this.exams.length === 0) {
        return []
      }
      let years = []

      Object.values(this.exams).forEach(exam => {
        years.push(exam.attributes.year)
      })

      return _.uniq(years)
    },
  },

  watch: {
    errors () {
      this.showErrors = this.errors
    },
    questions (questionIds) {
      this.questions_order = {}
      for (let i = 0; i < questionIds.length; i++) {
        this.questions_order[`template_${questionIds[i]}_order`] = i
      }

      this.selectValue({ attribute: 'questions_order', value: this.questions_order })
    },
  },

  mounted () {
    this.subscribable_groups = this.subscribable.subscribable_groups
    this.startdate = this.subscribable.startdate
    this.deadline = this.subscribable.deadline
    this.unsubscription_deadline = this.subscribable.unsubscription_deadline
    this.with_unsubscription = this.subscribable.with_unsubscription
    this.description = this.subscribable.description
    this.question = this.subscribable.question
    this.with_minimum_subscriptions = this.subscribable.minimum_subscriptions != null
    this.minimum_subscriptions = this.subscribable.minimum_subscriptions
    this.student_can_subscribe_group_members = this.subscribable.student_can_subscribe_group_members
    this.with_queue = this.subscribable.with_queue

    if (this.subscribable.sub_deadline_time == null) {
      this.selectValue({ attribute: 'sub_deadline_time', value: this.deadline_time })
      this.sub_deadline_time = this.deadline_time
    } else {
      this.sub_deadline_time = this.subscribable.sub_deadline_time
    }
    if (this.subscribable.sub_unsubscription_deadline_time == null) {
      this.selectValue({ attribute: 'sub_unsubscription_deadline_time', value: this.deadline_time })
      this.sub_unsubscription_deadline_time = this.deadline_time
    } else {
      this.sub_unsubscription_deadline_time = this.subscribable.sub_unsubscription_deadline_time
    }
    if (this.subscribable.sub_start_time == null) {
      this.selectValue({ attribute: 'sub_start_time', value: this.start_time })
      this.sub_start_time = this.start_time
    } else {
      this.sub_start_time = this.subscribable.sub_start_time
    }
  },

  methods: {
    selectValue ({ attribute, value }) {
      if (this.showErrors != null && typeof this.showErrors !== 'undefined' && this.showErrors.hasOwnProperty(attribute)) {
        Vue.delete(this.showErrors, attribute)
      }

      this.$store.dispatch('update_exam_subscribable', { name: attribute, value: value }).then(() => {
        this.emitFinish()
      })
    },

    emitFinish () {
      if (this.subscribable_groups != null && this.startdate != null && this.deadline != null && this.sub_start_time != null && this.sub_deadline_time != null &&
          (!this.with_unsubscription || (this.with_unsubscription && this.unsubscription_deadline != null && this.sub_unsubscription_deadline_time != null))
      ) {
        this.$emit('canFinishStep')
      } else {
        this.$emit('canNotFinishStep')
      }
    },

    error (name) {
      if (this.showErrors != null && typeof this.showErrors !== 'undefined' && this.showErrors.hasOwnProperty(name)) {
        return this.showErrors[name].join(' ')
      } else {
        return null
      }
    },
  },
}
</script>

<style lang="scss">
    .subscribable-details {
        margin: 20px 10px;
        padding: 20px;
        border: 1px solid lightgray;
        border-left: 3px solid #25167a;
    }

    .el-date-editor {
        width: 100% !important;

        .el-input__inner {
            width: 100% !important;
        }
    }

    .autocomplete ul {
        position: relative !important;
    }

    .error {
        border: 1px solid red !important;
        padding: 5px;
        margin-bottom: 5px;
    }

    .no-padding-side {
        padding-left: 2px;
        padding-right: 2px;
    }
</style>
